/**
 * Scrolls an element into view when the real scroll container is an ancestor
 * (e.g. dashboard `<main class="overflow-auto">`), not the window.
 */
function scrollElementRelativeToRoot(el: HTMLElement, root: Element, headerOffset: number): void {
  const elTop = el.getBoundingClientRect().top;
  const rootTop = root.getBoundingClientRect().top;
  const scrollable = root as HTMLElement;
  const nextTop = scrollable.scrollTop + (elTop - rootTop) - headerOffset;
  scrollable.scrollTo({ top: Math.max(0, nextTop), behavior: 'smooth' });
}

export function scrollFieldIntoViewOnMobile(el: HTMLElement, headerOffset = 120): void {
  const scrollHost =
    (el.closest('[data-app-scroll-container]') as HTMLElement | null) ??
    (el.closest('main') as HTMLElement | null);

  if (scrollHost) {
    const elTop = el.getBoundingClientRect().top;
    const hostTop = scrollHost.getBoundingClientRect().top;
    const nextTop = scrollHost.scrollTop + (elTop - hostTop) - headerOffset;
    scrollHost.scrollTo({ top: Math.max(0, nextTop), behavior: 'smooth' });
    return;
  }

  let node: HTMLElement | null = el;

  while (node) {
    const { overflowY } = window.getComputedStyle(node);
    const overflowAllows =
      overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay';
    const hasOverflow = node.scrollHeight > node.clientHeight;
    const isScrollable = overflowAllows && hasOverflow;

    if (isScrollable) {
      const elTop = el.getBoundingClientRect().top;
      const parentTop = node.getBoundingClientRect().top;
      const nextTop = node.scrollTop + (elTop - parentTop) - headerOffset;
      node.scrollTo({ top: Math.max(0, nextTop), behavior: 'smooth' });
      return;
    }

    node = node.parentElement;
  }

  const docRoot = (document.scrollingElement ?? document.documentElement) as HTMLElement | null;
  if (docRoot && docRoot.scrollHeight > docRoot.clientHeight) {
    scrollElementRelativeToRoot(el, docRoot, headerOffset);
    return;
  }

  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
